import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TrialState {
  questionsLeft: number;
  messages: Array<{ role: 'user' | 'assistant'; content: string }>;
  lastUsed: string | null;
  decrementQuestions: () => void;
  addMessage: (role: 'user' | 'assistant', content: string) => void;
  resetTrial: () => void;
}

export const useTrialStore = create<TrialState>()(
  persist(
    (set) => ({
      questionsLeft: 5,
      messages: [],
      lastUsed: null,
      decrementQuestions: () =>
        set((state) => {
          if (state.questionsLeft <= 0) return state;
          return {
            questionsLeft: state.questionsLeft - 1,
            lastUsed: new Date().toISOString()
          };
        }),
      addMessage: (role, content) =>
        set((state) => ({
          messages: [...state.messages, { role, content }],
        })),
      resetTrial: () =>
        set(() => ({
          questionsLeft: 5,
          messages: [],
          lastUsed: null,
        })),
    }),
    {
      name: 'trial-storage',
      onRehydrateStorage: () => (state) => {
        // Reset trial after 24 hours
        if (state?.lastUsed) {
          const lastUsed = new Date(state.lastUsed);
          const now = new Date();
          const hoursDiff = (now.getTime() - lastUsed.getTime()) / (1000 * 60 * 60);
          
          if (hoursDiff >= 24) {
            state.resetTrial();
          }
        }
      },
    }
  )
);